// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import { css } from "styled-components";

productShareLinkStyles.container = {
    gap: 40,
};

productShareLinkStyles.recipientNameGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-right: 10px;
    `,
};

productShareLinkStyles.recipientEmailGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-left: 10px;
    `,
};

productShareLinkStyles.yourNameGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-right: 10px;
    `,
};

productShareLinkStyles.yourEmailGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-left: 10px;
    `,
};

productShareLinkStyles.yourMessageTextArea = {
    cssOverrides: {
        formField: css`
            & textarea {
                resize: none;
            }

            & label {
                top: -14px !important;
            }
        `,
    },
};
